export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";